import BaseEntityDto from "@/models/Shared/BaseEntityDto";

export default class PersonDto extends BaseEntityDto {
    firstName = '';
    lastName = '';
}